import React from "react";
import { fleetrifyIcons } from "../../../../assets/icons/icons";

interface SummaryCardProps {
    title: string;
    value: number;
    changeText: string;
    changeDirection: "up" | "down";
    icon?: React.ReactNode;
}

export const DashboardFleetSummaryCardTwo: React.FC<SummaryCardProps> = ({
    title,
    value,
    changeText,
    icon,
    changeDirection,
}) => {
    const isUp = changeDirection === "up";
    return (
        <div className="bg-white rounded-[12px] shadow-sm p-4 h-[150px] flex flex-col justify-between border border-gray-200 w-full">
            <div className="space-y-2">
                <div className="flex items-center justify-between">
                    <h4 className="text-sm font-medium text-[#00032A]">{title}</h4>
                    {icon}
                </div>
                <p className="text-2xl font-bold text-[#143887] mt-1">{value}</p>
            </div>
            <div
                className={`flex items-center gap-1 mt-1 text-xs font-medium ${isUp ? "text-green-600" : "text-red-500"
                    }`}
            >
                {isUp ? (
                    fleetrifyIcons.rateUp
                ) : (
                    fleetrifyIcons.rateDown
                )}
                {changeText}
            </div>
        </div>
    );
};
